/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsSwapV: {
  name: 'arrows-swap-v';
  data: string;
} = {
  name: 'arrows-swap-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.354.646a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L3.5 2.207V9a.5.5 0 0 0 1 0V2.207l2.146 2.147a.5.5 0 1 0 .708-.708l-3-3ZM12.5 7a.5.5 0 0 0-1 0v6.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L12.5 13.793V7Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
